export default "__VITE_ASSET__fvG4G0vT__"